<script>
import { mapGetters } from 'vuex';
import { frontendURL } from 'dashboard/helper/URLHelper';
export default {
  components: {},
  directives: {
    focus: {
      inserted(el) {
        el.focus();
      },
    },
  },
  props: {
    hasAppliedFiltersOrActiveFolders: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters({
      accountId: 'getCurrentAccountId',
    }),
    searchUrl() {
      return frontendURL(`accounts/${this.accountId}/search`);
    },
  },
};
</script>

<template>
  <div class="relative">
    <div
      class="flex flex-row gap-1 px-3 justify-between items-center"
      :class="{ 'pb-3 border-b border-n-weak': hasAppliedFiltersOrActiveFolders }"
    >
      <router-link
        :to="searchUrl"
        class="inline-flex items-center flex-1 rounded-full min-w-0 gap-1 px-2 py-2 text-left rtl:mr-2.5 rtl:text-right bg-n-background outline-1 outline outline-n-container hover:outline-n-brand transition-all search-container"
      >
        <div class="flex flex-shrink-0">
          <fluent-icon
            icon="search"
            class="search--icon text-n-slate-11 transition-colors"
            size="16"
          />
        </div>
        <p
          class="mb-0 overflow-hidden text-sm search--label whitespace-nowrap text-ellipsis text-n-slate-9"
        >
          Pesquisar
        </p>
      </router-link>
    </div>
  </div>
</template>

<style scoped lang="scss">
.search-container:hover .search--icon {
  @apply text-n-brand;
}
</style>
